/*
 * @Author: XLT
 * @LastEditors: XLT
 * @Description:
 */
import tagApply from "@/pages/tag/tagApply/tagApply.vue";
import tagApplyHand from "@/pages/tag/tagApplyHand/tagApplyHand.vue";
import tagBatch from "@/pages/tag/tagBatch/tagBatch.vue";
import tagDist from "@/pages/tag/tagDist/tagDist.vue";

export default [
  {
    path: "/tag/apply",
    name: "tagApply",
    component: tagApply,
    meta: {
      title: "标签申请",
      noCache: true,
      affix: true,
      path: ["追溯标签管理", "标签申请"]
    }
  },
  {
    path: "/tag/apply/hand",
    name: "tagApplyHand",
    component: tagApplyHand,
    meta: {
      title: "标签审核",
      noCache: true,
      affix: true,
      path: ["追溯标签管理", "标签审核"]
    }
  },
  {
    path: "/tag/batch",
    name: "tagBatch",
    component: tagBatch,
    meta: {
      title: "标签批次",
      noCache: true,
      affix: true,
      path: ["追溯标签管理", "标签批次"]
    }
  },
  {
    path: "/tag/dist",
    name: "tagDist",
    component: tagDist,
    meta: {
      title: "标签分配",
      noCache: true,
      affix: true,
      path: ["追溯标签管理", "标签分配"]
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/tag.js